import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import vSelect from 'vue-select'
import VeeValidate from 'vee-validate';
import 'prismjs'
import 'prismjs/themes/prism.css'
import "prismjs/plugins/autolinker/prism-autolinker.min";
import "prismjs/plugins/autolinker/prism-autolinker.css";
import 'vue-select/dist/vue-select.css';

// Define custom Error for api mservices
window.ApiError = function (object) {
    this.data = object;
};
window.ApiError.prototype = Object.create(Error.prototype);
window.ApiError.prototype.constructor = window.ApiError;

import en from './lang/en'
import ge from './lang/ge'
import LangService from './services/LangService';

Vue.config.productionTip = false;
Vue.use(VeeValidate);
Vue.use(VueI18n);
Vue.component('v-select', vSelect);

const messages = {
    en: en,
    ge: ge
};

const i18n = new VueI18n({
    locale: LangService.getLang(),
    messages
});

new Vue({
    el: '#app',
    i18n,
    render: h => h(App)
}).$mount('#app');

